$(document).ready(() => {
  $('.navbar-hook .navbar-sub__link[href*=\\#], .scrollto').on('click', (e) => {
    e.preventDefault();
    const target = $(e.target)[0].hash;
    $('html, body').animate(
      {
        scrollTop: $(target).offset().top - 40,
      },
      700,
    );
  });
});

/* function setActiveClass() {
  if ($('.navbar-hook a').length === 0) {
    return false;
  }


  const getBlocks = (linksA) => {
    let items;
    items = ' ';
    linksA.each((index) => {
      const link = $(linksA[index]);
      if ($(link.attr('href')).length) {
        if (items === ' ') {
          items = $(link.attr('href'));
        }
        items = items.add(link.attr('href'));
      }
    });
    return items;
  };

  const links = $('.navbar-hook a');
  const blocks = getBlocks(links);

  return blocks.each((index) => {
    const block = $(blocks[index]);
    const link = $(`.navbar-hook [href='#${block.attr('id')}']`);
    let windowH = $(window).height();
    $(window).resize(() => {
      windowH = $(window).height();
    });
    const checkMenu = () => {
      const { top } = block.offset();
      const bottom = top + block.outerHeight();
      const windowScroll = $(window).scrollTop() + 0.4 * windowH;
      if (top < windowScroll && bottom > windowScroll) {
        return link
          .addClass('active')
          .closest('li')
          .siblings()
          .find('a')
          .removeClass('active');
      }
      return null;
    };
    checkMenu();
    return $(window).scroll(() => checkMenu());
  });
}

setActiveClass(); */
